import { applyMiddleware, compose, createStore } from 'redux';

export default (reducers, middlewares) => {
  const enhancer = process.env.NODE_ENV === 'development' ? compose(applyMiddleware(...middlewares)) : applyMiddleware(...middlewares);
  return createStore(reducers, enhancer);
};
